import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { cn } from "@util/helpers";

type WinnersTabProps = {
  /** Years array used to display the years tabs */
  years: string[];
  /** Classname to add the number of column for the tabs */
  basisClass: string;
  /** Function to set the selected tab*/
  setSelectedYear: (year: string) => void;
  /** Function to toggle the display of tabs*/
  setShowTabs: (state: boolean) => void;
  /** Selected year to show the respective winners */
  selectedYear: string;
};
/**
 * Component to render tabs for winners page
 */
const WinnersTab = ({
  years,
  setSelectedYear,
  setShowTabs,
  basisClass,
  selectedYear,
}: WinnersTabProps): React.ReactElement => {
  return (
    <div className="mb-2 flex w-8/12 flex-wrap border border-gray-200 bg-white p-4 shadow-sm">
      {years.map((year) => (
        <ButtonFactory
          key={year}
          buttonType={ButtonType.Primary}
          text={year}
          onClick={() => {
            setSelectedYear(year);
            setShowTabs(false);
          }}
          className={cn(
            "rounded-none bg-white px-4 py-2 text-base text-gray-875 transition-colors hover:bg-gray-100",
            basisClass,
            { "bg-gray-650 text-white": selectedYear === year }
          )}
        />
      ))}
    </div>
  );
};

export default WinnersTab;
